import { Card, CardBody, Flex, Box, Text } from "@chakra-ui/react";
import {
  MetricIcon,
  AcceptedIcon,
  AcceptedIconSmall,
  PendingMetricIcon,
  PendingIcon,
  AcceptedMetricIcon,
  IncomingIcon,
  IncomingIconSmall,
  PendingIconSmall,
  RejectedIconSmall,
  RejectedMetricIcon,
} from "../assets/svgs/Icons";
import { useEffect, useState } from "react";
import { getMetric } from "../api";
import { useNavigate } from "react-router-dom";

const MetricCard = ({ metrics }) => {
  //   const getMetricData = async () => {
  //     let metricsData = await getMetric();
  //     ;
  //   };

  const navigate = useNavigate();

  useEffect(() => {}, []);

  return (
    <Flex
      gap="10"
      alignContent="center"
      margin="16px"
      flexWrap={"wrap"}
      color={"brand.black"}
    >
      <Card
        w="250px"
        h="120px"
        bg={"#B1DFFF"}
        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
        overflow="hidden"
        borderRadius="10px"
        _hover={{ cursor: 'pointer' }}
        onClick={() => {
          navigate("/client/transaction-certificates?tab=incoming");
        }}
      >
        <CardBody>
          <Flex flex="1" gap="10" alignItems="center" flexWrap="wrap">
            <Box alignContent="center">
              <IncomingIconSmall />
            </Box>
            <Box textAlign={"center"}>
              <Text fontSize={"20px"} fontWeight={"800"}>
                Incoming
              </Text>
              <Text fontSize={"34px"} fontWeight={"600"}>
                {metrics?.data?.INCOMING || 0}
              </Text>
            </Box>
          </Flex>
        </CardBody>
      </Card>

      <Card
        w="250px"
        h="120px"
        bg="#FFD5D3"
        overflow="hidden"
        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
        borderRadius="10px"
        _hover={{ cursor: 'pointer' }}
        onClick={() => {
          navigate("/client/transaction-certificates?tab=pending");
        }}
      >
        <CardBody>
          <Flex flex="1" gap="10" alignItems="center" flexWrap="wrap">
            <Box alignContent="center">
              <PendingIconSmall />
            </Box>
            <Box textAlign={"center"}>
              <Text fontSize={"20px"} fontWeight={"800"}>
                Pending
              </Text>
              <Text fontSize={"34px"} fontWeight={"600"}>
                {metrics?.data?.PENDING || 0}
              </Text>
            </Box>
          </Flex>
        </CardBody>
      </Card>

      <Card
        w="250px"
        h="120px"
        bg="#B8C9EA"
        overflow="hidden"
        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
        borderRadius="10px"
      >
        <CardBody>
          <Flex flex="1" gap="10" alignItems="center" flexWrap="wrap">
            <Box alignContent="center">
              <AcceptedIconSmall />
            </Box>
            <Box textAlign={"center"}>
              <Text fontSize={"20px"} fontWeight={"800"}>
                Approve
              </Text>
              <Text fontSize={"34px"} fontWeight={"600"}>
                {metrics?.data?.APPROVE || 0}
              </Text>
            </Box>
          </Flex>
        </CardBody>
      </Card>

      <Card
        w="250px"
        h="120px"
        bg="#FE96A6"
        overflow="hidden"
        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
        borderRadius="10px"
      >
        <CardBody>
          <Flex flex="1" gap="10" alignItems="center" flexWrap="wrap">
            <Box alignContent="center">
              <RejectedIconSmall />
            </Box>
            <Box textAlign={"center"}>
              <Text fontSize={"20px"} fontWeight={"800"}>
                Reject
              </Text>
              <Text fontSize={"34px"} fontWeight={"600"}>
                {metrics?.data?.REJECT || 0}
              </Text>
            </Box>
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  );
};

export default MetricCard;
